

import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';
import { computed, onMounted, ref, watch } from 'vue';
import { external } from '../apis/external';
import { useAuthStore } from '../stores/auth';
import { storeToRefs } from 'pinia';
import { customer } from '../apis/customer';

import Button from 'primevue/button';
import IftaLabel from 'primevue/iftalabel';
import InputText from 'primevue/inputtext';
import Select from 'primevue/select';
import SelectButton from 'primevue/selectbutton';
import Divider from 'primevue/divider';
import { useToast } from 'primevue/usetoast';
import { showVuePopup } from '../utils/showVuePopup';
import WalletDeposit from './WalletDeposit.vue';
import { useSession } from '../stores/session';

export default {
	name: 'WalletUpdate',
	components: {
		Tabs,
		TabPanels,
		TabPanel,
		TabList,
		Tab,
		IftaLabel,
		InputText,
		Select,
		SelectButton,
		Button,
		Divider,
	},
	props: {
		tabs: {
			type: String,
			default: 'bank',
		},
	},
	setup(props) {
		const auth = useAuthStore();
		auth.hydrate();
		const { profile } = storeToRefs(auth);

		const toast = useToast();
		const session = useSession();

		const tabs = ref<string>(props.tabs)

		const formBankUpdate = ref({
			firstName: profile.value?.firstName ?? '',
			lastName: profile.value?.lastName ?? '',
			firstNameEn: profile.value?.firstNameEn ?? '',
			lastNameEn: profile.value?.lastNameEn ?? '',
			bankCode: profile.value?.customerBankName ?? '',
			bankNumber: profile.value?.customerBankAccount ?? '',
			autoPromotion: profile.value?.isAutoPromotion ?? false,
		});

		const formP2pUpdate = ref({
			uid: profile.value?.peer2PayUID ?? '',
			autoPromotion: profile.value?.isAutoPromotion ?? false,
		});

		const optionTabWalletUpdate = ref({
			bankCode: [],
			autoPromotion: [
				{ name: 'เปิด', value: true },
				{ name: 'ปิด', value: false },
			],
		});

		const isBankUpdated = computed(() => !!profile.value?.customerBankName && !!profile.value?.customerBankAccount);

		const isNameEnUpdated = computed(() => !!profile.value?.firstNameEn && !!profile.value?.lastNameEn);

		const isP2pUpdated = computed(() => !!profile.value?.peer2PayUID && profile.value.isSyncPeer2Pay);

		const handleUpdateInformation = async (payload: any): Promise<boolean> => {
			try {
				const resp = await external.updateInformation(payload);

				if (resp.code === '8017') {
					alert(resp.message);
					await auth.logout();
					window.location.reload();
					return false;
				}

				if (resp.code !== '0') throw new Error(resp.message);

				return true;
			} catch (error: any) {
				toast.add({ severity: 'error', summary: 'เกิดข้อผิดพลาดบางอย่าง', detail: error, life: 3000 });
				return false;
			}
		};

		const handleUpdateBank = async (payload: any) => {
			try {
				const resp = await external.updateBank(payload);

				if (resp.code === '8017') {
					alert(resp.message);
					await auth.logout();
					window.location.reload();
					return;
				}

				if (resp.code !== '0') throw new Error(resp.message);

				await auth.fetchData();
				auth.hydrate();

				toast.add({ severity: 'info', summary: resp.message, detail: 'อัปเดตบัญชีธนาคารสำเร็จ', life: 3000 });
			} catch (error: any) {
				toast.add({ severity: 'error', summary: 'เกิดข้อผิดพลาดบางอย่าง', detail: error, life: 3000 });
			}
		};


		const handleBanksList = async () => {
			try {
				const resp = await external.bankList({ data: null });

				if (resp.code === '8017') {
					alert(resp.message);
					await auth.logout();
					window.location.reload();
					return;
				}

				if (resp.code !== '0') throw new Error(resp.message);

				optionTabWalletUpdate.value.bankCode = resp.result?.banks || [];
			} catch (error) {
				toast.add({ severity: 'error', summary: 'เกิดข้อผิดพลาดบางอย่าง', detail: error, life: 3000 });
			}
		};

		const handleUpdatePeer2PayUID = async (payload: any) => {
			try {
				const resp = await customer.updatePeer2PayUID(payload);

				if (resp.code === '8017') {
					alert(resp.message);
					await auth.logout();
					window.location.reload();
					return;
				}

				if (resp.code !== '0') throw new Error(resp.message);

				await auth.fetchData();
				auth.hydrate();

				toast.add({ severity: 'info', summary: resp.message, detail: 'อัปเดตบัญชีธนาคารสำเร็จ', life: 3000 });


				session.set('navbar_sub', 'wallet:deposit');
				sessionStorage.setItem('update_p2p', '1');
				await showVuePopup(WalletDeposit);
			} catch (error: any) {
				toast.add({ severity: 'error', summary: 'เกิดข้อผิดพลาดบางอย่าง', detail: error, life: 3000 });
			}
		};

		const validateBankUpdate = (): boolean => {
			if (formBankUpdate.value.firstName === '' || formBankUpdate.value.lastName === '' || formBankUpdate.value.bankCode === '') {
				return false;
			}

			formBankUpdate.value.firstNameEn = formBankUpdate.value.firstNameEn.trim();
			formBankUpdate.value.lastNameEn = formBankUpdate.value.lastNameEn.trim();
			const nameEnPattern = /^[a-zA-Z\s]+$/;
			if (!nameEnPattern.test(formBankUpdate.value.firstNameEn) || !nameEnPattern.test(formBankUpdate.value.lastNameEn)) {
				toast.add({ severity: 'warn', summary: 'กรุณากรอกชื่อ-นามสกุล (อังกฤษ) ให้ถูกต้อง', detail: 'กรอกได้เฉพาะภาษาอังกฤษเท่านั้น', life: 3000 });
				return false;
			}

			formBankUpdate.value.bankNumber = formBankUpdate.value.bankNumber.replace(/-/g, '');
			return !(formBankUpdate.value.bankNumber === '' ||
				formBankUpdate.value.bankNumber.length > 20 ||
				!(/^\d+$/.test(formBankUpdate.value.bankNumber)));
		};

		const handleBankUpdateSubmit = async () => {
			if (!validateBankUpdate()) return;

			const infoPayload = {
				firstName: '',
				lastName: '',
				firstNameEN: formBankUpdate.value.firstNameEn,
				lastNameEN: formBankUpdate.value.lastNameEn,
				promptPayID: '',
			};

			const bankPayload = {
				bankName: formBankUpdate.value.bankCode,
				accountNo: formBankUpdate.value.bankNumber,
				firstName: formBankUpdate.value.firstName,
				lastName: formBankUpdate.value.lastName,
				firstNameEn: formBankUpdate.value.firstNameEn,
				lastNameEn: formBankUpdate.value.lastNameEn,
				middleName: '',
				isAutoPromotion: formBankUpdate.value.autoPromotion,
			};

			// อัปเดตชื่อผ่าน update-information ก่อน ถ้าสำเร็จค่อยอัปเดตบัญชีธนาคาร
			if (!(await handleUpdateInformation(infoPayload))) return;
			await handleUpdateBank(bankPayload);
		};

		const handleP2pUpdateSubmit = async () => {
			if (
				formP2pUpdate.value.uid === '' ||
				formP2pUpdate.value.uid.length > 20 ||
				!/^\d+$/.test(formP2pUpdate.value.uid)
			) {
				return;
			}

			const payload = {
				peer2PayUID: formP2pUpdate.value.uid,
				isAutoPromotion: formP2pUpdate.value.autoPromotion,
			};
			await handleUpdatePeer2PayUID(payload);
		};

		watch(tabs, (value) => {
			if (value === 'bank') {
				if (isBankUpdated.value) return;
				handleBanksList();
			}
		});

		onMounted(() => {
			handleBanksList();
		})

		return {
			tabs,
			formBankUpdate,
			formP2pUpdate,
			optionTabWalletUpdate,
			isBankUpdated,
			isNameEnUpdated,
			isP2pUpdated,
			handleBankUpdateSubmit,
			handleP2pUpdateSubmit,
		}
	},
}

